import React, { Component } from 'react'
import RunbookGraph from './index'

import { Card, Elevation } from '@blueprintjs/core'

const Status = ({ status }) => {
    return (
        <span
            className="status"
            style={{
                backgroundColor: RunbookGraph.statusDetails[status].color,
            }}
        >
            {RunbookGraph.statusDetails[status].name}
        </span>
    )
}
class ActionInfo extends Component {
    renderDeviceAction() {
        const { count, deviceNodes } = this.props.actionData

        return (
            <div>
                <div>
                    {' '}
                    <span className="bold"> Device Number </span> {count}{' '}
                </div>
                <ul className="device-list">
                    {Object.values(deviceNodes).map((node) => {
                        return (
                            <li key={node.data.name}>
                                {' '}
                                {node.data.name} -{' '}
                                <Status status={node.data.status} />{' '}
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    render() {
        const { actionUid, actionData } = this.props
        if (actionUid === null) {
            return null
        }

        const { name, status, type } = actionData

        return (
            <Card elevation={Elevation.TWO}>
                <h5>{name}</h5>
                <div>
                    {' '}
                    <span className="bold"> Status </span>{' '}
                    <Status status={status} />{' '}
                </div>
                {type === 'devices' ? this.renderDeviceAction() : null}
            </Card>
        )
    }
}

export default ActionInfo
